import _ from 'lodash';
import * as JobUsageBudgetRepository from '../Repository/BudgetCappingRepository';
import { setApiStatus } from './ApiStatusActions';
import { setNotification } from './ActionCreators/ConnectActions';
import {
  SET_AVAILABLE_JOB_USAGE_BUDGET,
  SET_JOB_USAGE_BUDGET_REQUESTS,
  SET_UPDATED_JOB_USAGE_REQUEST_STATUS,
  SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST,
  SET_AVAILABLE_USER_BUDGET,
  SET_USER_BUDGET_REQUESTS,
  SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST,
  SET_UPDATED_USER_REQUEST_STATUS,
} from './ActionCreators/BudgetCappingActionCreator';

const INPROGRESS = 'INPROGRESS';
const COMPLETED = 'COMPLETED';
const FAILED = 'FAILED';

function fetchJobUsageAvailableBudget(jobId) {
  return async dispatch => {
    try {
      const response = await JobUsageBudgetRepository.fetchJobUsageBudget(jobId);
      const payload = response.data;
      dispatch({
        type: SET_AVAILABLE_JOB_USAGE_BUDGET,
        payload,
      });
    } catch (error) {
      const errorResponse = error.response;
      if (errorResponse.status === 404) {
        const jobId = _.get(errorResponse, ['data', 'Error', 'Info', 'JobId'], null);
        const payload = {
          AvailableBudget: null,
          TotalBudget: null,
          JobId: jobId,
        };
        dispatch({
          type: SET_AVAILABLE_JOB_USAGE_BUDGET,
          payload,
        });
        return;
      }
      dispatch(
        setNotification('ERROR', {
          messageId: 'oopsSomethingJustWentWrong',
        })
      );
    }
  };
}

function fetchAllJobUsageBudgetRequests(data, pageSize, pageNumber) {
  return async dispatch => {
    try {
      dispatch(setApiStatus({ apiName: 'jobUsageBudgetRequestsApiStatus', status: INPROGRESS }));
      const response = await JobUsageBudgetRepository.fetchAllJobUsageBudgetRequests(data, pageSize, pageNumber);
      const payload = response.data;
      dispatch(setApiStatus({ apiName: 'jobUsageBudgetRequestsApiStatus', status: COMPLETED }));
      dispatch({
        type: SET_JOB_USAGE_BUDGET_REQUESTS,
        payload,
      });
    } catch (e) {
      dispatch(setApiStatus({ apiName: 'jobUsageBudgetRequestsApiStatus', status: FAILED }));
      dispatch(
        setNotification('ERROR', {
          messageId: 'oopsSomethingJustWentWrong',
        })
      );
    }
  };
}

function postBudgetCappingRequest(jobId, totalBudget) {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      dispatch(setApiStatus({ apiName: 'jobLevelPostCreditsRequestApiStatus', status: INPROGRESS }));
      await JobUsageBudgetRepository.postBudgetCappingRequest(jobId, totalBudget);
      if (jobId) {
        dispatch({
          type: SET_UPDATED_JOB_USAGE_REQUEST_STATUS,
          payload: {
            JobId: jobId,
            RequestStatus: 'Pending',
          },
        });
      } else {
        const currentUserGuid = state.UserSessionReducer.user.sub;
        const userId = _.get(state.UserReducer.ByGuId, [currentUserGuid, 'Id'], null);
        dispatch({
          type: SET_UPDATED_USER_REQUEST_STATUS,
          payload: {
            UserId: userId,
            RequestStatus: 'Pending',
          },
        });
      }

      dispatch(setApiStatus({ apiName: 'jobLevelPostCreditsRequestApiStatus', status: COMPLETED }));
      dispatch(
        setNotification('SUCCESS', {
          messageId: jobId ? 'requestHasBeenSentToUpdateJobLimit' : 'requestHasBeenSentToUpdateUserBudgetLimit',
        })
      );
    } catch (e) {
      dispatch(setApiStatus({ apiName: 'jobLevelPostCreditsRequestApiStatus', status: FAILED }));
      dispatch(
        setNotification('ERROR', {
          messageId: 'oopsSomethingJustWentWrong',
        })
      );
    }
  };
}

function updateBudgetRequestStatus(
  credits,
  status,
  jobId,
  requestId,
  LastAllocatedBudget,
  CurrentAllocatedBudget,
  activeTab
) {
  return async dispatch => {
    try {
      const payload = {
        BudgetUnits: credits,
        Status: status,
        JobId: jobId,
      };
      dispatch({
        type:
          activeTab === 'jobCredits'
            ? SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST
            : SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST,
        payload: {
          RequestId: requestId,
          RequestStatus: INPROGRESS,
          CurrentAllocatedBudget: status === 'Rejected' ? LastAllocatedBudget : credits,
          LastAllocatedBudget,
          LastUpdateTime: new Date().toISOString(),
        },
      });
      await JobUsageBudgetRepository.updateBudgetRequestStatus(requestId, payload);
      dispatch({
        type:
          activeTab === 'jobCredits'
            ? SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST
            : SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST,
        payload: {
          RequestId: requestId,
          RequestStatus: status,
          CurrentAllocatedBudget: status === 'Rejected' ? LastAllocatedBudget : credits,
          LastAllocatedBudget,
          LastUpdateTime: new Date().toISOString(),
        },
      });
    } catch (e) {
      dispatch({
        type: SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST,
        payload: {
          RequestId: requestId,
          RequestStatus: 'Pending',
          CurrentAllocatedBudget,
          LastAllocatedBudget,
        },
      });
      dispatch(
        setNotification('ERROR', {
          messageId: 'oopsSomethingJustWentWrong',
        })
      );
    }
  };
}

function fetchUserAvailableBudget() {
  return async dispatch => {
    try {
      const response = await JobUsageBudgetRepository.fetchUserBudget();
      const payload = response.data;
      dispatch({
        type: SET_AVAILABLE_USER_BUDGET,
        payload,
      });
    } catch (error) {
      const errorResponse = error.response;
      if (errorResponse.status === 404) {
        const jobId = _.get(errorResponse, ['data', 'Error', 'Info', 'UserId'], null);
        const payload = {
          AvailableBudget: null,
          TotalBudget: null,
          JobId: jobId,
        };
        dispatch({
          type: SET_AVAILABLE_USER_BUDGET,
          payload,
        });
        return;
      }
      dispatch(
        setNotification('ERROR', {
          messageId: 'oopsSomethingJustWentWrong',
        })
      );
    }
  };
}

function fetchAllUserBudgetRequests(data, pageSize, pageNumber) {
  return async dispatch => {
    try {
      dispatch(setApiStatus({ apiName: 'jobUsageBudgetRequestsApiStatus', status: INPROGRESS }));
      const response = await JobUsageBudgetRepository.fetchAllUserBudgetRequests(data, pageSize, pageNumber);
      const payload = response.data;
      dispatch(setApiStatus({ apiName: 'jobUsageBudgetRequestsApiStatus', status: COMPLETED }));
      dispatch({
        type: SET_USER_BUDGET_REQUESTS,
        payload,
      });
    } catch (e) {
      dispatch(setApiStatus({ apiName: 'jobUsageBudgetRequestsApiStatus', status: FAILED }));
      dispatch(
        setNotification('ERROR', {
          messageId: 'oopsSomethingJustWentWrong',
        })
      );
    }
  };
}

export {
  fetchJobUsageAvailableBudget,
  fetchAllJobUsageBudgetRequests,
  postBudgetCappingRequest,
  updateBudgetRequestStatus,
  fetchUserAvailableBudget,
  fetchAllUserBudgetRequests,
};
